import { forwardRef, type InputHTMLAttributes, type SelectHTMLAttributes, type TextareaHTMLAttributes } from 'react';

export const inputClass =
  'h-8 w-full rounded-md px-3 text-sm transition-colors focus:outline-none bg-[var(--color-surface)] text-[var(--color-ink)] border border-[var(--color-line-heavy)] placeholder:text-[var(--color-ink-faint)]';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className = '', ...props }, ref) => (
    <input ref={ref} className={`${inputClass} ${className}`} {...props} />
  ),
);
Input.displayName = 'Input';

export const textareaClass = inputClass.replace('h-8 ', '').replace('px-3', 'px-3 py-1.5');

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className = '', ...props }, ref) => (
    <textarea ref={ref} className={`${textareaClass} ${className}`} {...props} />
  ),
);
Textarea.displayName = 'Textarea';

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className = '', ...props }, ref) => (
    <select ref={ref} className={`${inputClass} ${className}`} {...props} />
  ),
);
Select.displayName = 'Select';
